// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__RbMpe","authContainer":"Auth_authContainer__YdyA4","authImage":"Auth_authImage__nOXSI","authBtn":"Auth_authBtn__BF90M","btn":"Auth_btn__zcruV"};